import axios from "axios";
import { ACQUIRED_ASSETS } from "network/endpoints";
import ewbApi from "network/ewbApi";

export const getAcquiredVehiclePage = () =>
  axios.get(ACQUIRED_ASSETS.acquiredVehiclesPage);

export const getAcquiredVehicleList = () =>
  ewbApi.get(ACQUIRED_ASSETS.acquiredVehicleList);

export const getAcquiredPropertiesPage = () =>
  axios.get(ACQUIRED_ASSETS.acquiredPropertiesPage);

export const getAcquiredPropertiesList = () =>
  ewbApi.get(ACQUIRED_ASSETS.acquiredPropertiesList);
